import { useMutation, useQuery } from "@tanstack/react-query";
import { SubscriptionDto } from "../../../services/dto";
import { IActionResponse, IActionResult } from "../../../assets/utils/lib";
import { SubscriptionClient } from "../../../services/proxies";
import { SearchDto } from "../../../assets/utils/lib/searchDto";
import { Constants } from "../../../assets/utils/lib/constants";

export namespace SubscriptionService {
  const subscriptionClient = new SubscriptionClient();

  export const save = () =>
    useMutation<IActionResult<SubscriptionDto>, Error, SubscriptionDto>({
      mutationFn: async (payload: SubscriptionDto) => {
        return await subscriptionClient.saveSubscriptionAsync(payload);
      },
    });

  export const getAllSubscriptionsQuery = () =>
    useQuery({
      queryKey: ["allSubscriptionsQuery"],
      queryFn: async () => await subscriptionClient.getAllSubscriptionsAsync(),
    });

  export const getSubscriptionQuery = (subscriptionId: string | undefined) =>
    useQuery({
      queryKey: ["subscriptionQuery", subscriptionId],
      queryFn: async () =>
        await subscriptionClient.getSubscriptionAsync(subscriptionId),
      enabled: Boolean(
        subscriptionId && subscriptionId !== Constants.emptyGuid
      ),
    });

  export const getSubscriptionsQuery = (communityId: string | undefined) =>
    useQuery({
      queryKey: ["subscriptionsQuery", communityId],
      queryFn: async () =>
        await subscriptionClient.getSubscriptionsAsync(communityId),
      enabled: Boolean(communityId && communityId !== Constants.emptyGuid),
    });

  export const gridQuery = (searchQuery: SearchDto) =>
    useQuery({
      queryKey: ["subscriptionGridQuery", searchQuery],
      queryFn: async () =>
        await subscriptionClient.searchSubscriptionsAsync(searchQuery),
      placeholderData: (previousData) => previousData,
    });

  export const deActivateSubscription = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (subscriptionId: string | undefined) => {
        return await subscriptionClient.deActivateSubscriptionAsync(
          subscriptionId
        );
      },
    });
}
